import script from "./DropdownButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownButton.vue?vue&type=style&index=0&id=70b513e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b513e0"]])

export default __exports__